import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Toaster } from '../ui/sonner';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <Header />
      <main>{children}</main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
};

export default Layout;
